import script from "./ModalPromocionProducto.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalPromocionProducto.vue?vue&type=script&setup=true&lang=ts"

import "./ModalPromocionProducto.vue?vue&type=style&index=0&id=6886a452&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6886a452"]])

export default __exports__